<ul class="navbar-nav">
  @for (item of navItems.items$ | async; track $index) {
    <ng-container *abpVisible="!item.visible || item.visible(item)">
      <li class="nav-item d-flex align-items-center" *abpPermission="item.requiredPolicy">
        @if (item.component) {
          <ng-container
            [ngComponentOutlet]="item.component"
            [ngComponentOutletInjector]="item | toInjector"
          ></ng-container>
        } @else {
          <div [innerHTML]="item.html" (click)="item.action ? item.action() : null"></div>
        }
      </li>
    </ng-container>
  }
</ul>
